import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import _typeof from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/typeof";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.to-string";

/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
/**
 * ログイン時のユーザ名はメールアドレスのみ
 * @param {string} str
 * @returns {Boolean}
 */

export function validUsername(str) {
  return str.trim().length > 0;
}
/**
 * @param {string} url
 * @returns {Boolean}
 */

export function validURL(url) {
  var reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */

export function validLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */

export function validUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */

export function validAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
/**
 * @param {string} email
 * @returns {Boolean}
 */

export function validEmail(email) {
  var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */

export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }

  return false;
}
/**
 * @param {Array} arg
 * @returns {Boolean}
 */

export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }

  return Array.isArray(arg);
}
export function depthFirstSearch(affiliations, affiliation, optionId) {
  var result = [];
  var treeMapAffiliation = [];

  function indexWhere(array, conditionFn) {
    var item = array.find(conditionFn);
    return array.indexOf(item);
  }

  affiliations.map(function (item) {
    return affiliationSearch(item);
  });

  function affiliationSearch(object) {
    if (treeMapAffiliation) {
      var indexOfTreeAffiliation = indexWhere(treeMapAffiliation, function (item) {
        return item.parent_id === object.parent_id;
      });

      if (indexOfTreeAffiliation >= 0) {
        treeMapAffiliation.splice(indexOfTreeAffiliation, treeMapAffiliation.length);
      }
    }

    treeMapAffiliation.push(object);

    if (affiliation.length && affiliation) {
      var checkNotEmpty = affiliation.filter(function (item) {
        var itemId = _typeof(item) === 'object' && item !== null ? item.id : item;
        return itemId != null && itemId.toString() === object.id.toString();
      });

      if (checkNotEmpty.length) {
        var matchedId = _typeof(checkNotEmpty[0]) === 'object' && checkNotEmpty[0] !== null ? checkNotEmpty[0].id : checkNotEmpty[0];
        treeMapAffiliation.forEach(function (item) {
          var indexOfFloor = treeMapAffiliation.indexOf(item);
          item.paddingFloorInTreeAffiliation = indexOfFloor * 24;

          if (item.id != null && matchedId != null && item.id.toString() === matchedId.toString()) {
            item.is_directly = true;
          }

          result.push(item);
        });
      }
    }

    return object.affiliations.map(function (ite) {
      return affiliationSearch(ite);
    });
  }

  return _toConsumableArray(new Set(result));
} // 組織ツリーから、指定したIDの組織を探す（見つからなければ null）

export function findAffiliationById(affiliations, id) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (affiliations || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;
      if (String(item.id) === String(id)) return item;
      var found = findAffiliationById(item.affiliations, id);
      if (found) return found;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
} // 組織ツリー（全てのグループ入り）で選んだ組織から、組織ボタンの表示に使う経路と、社員検索に使う組織IDの一覧を求める。
// 実在の組織ならその組織と配下すべて、上位の「全てのグループ」(-1) なら絞り込みなし、
// 組織内の「全てのグループ」(-2 以下) ならその親の配下すべて（親自身は含まない）を対象にする

export function resolveAffiliationSelection(affiliations, selectedId) {
  var pathToListItem = [];
  var listAllIdsFromLastItem = [];

  function subReloadAffiliation(_affiliation, accept) {
    // acceptは、父親のIDを取得しないことを意味します
    if (accept && _affiliation.id >= 0) {
      listAllIdsFromLastItem.push(_affiliation.id);
    }

    return _affiliation.affiliations.map(function (ite) {
      return subReloadAffiliation(ite, true);
    });
  }

  function reloadAffiliation(affiliation) {
    // eslint-disable-next-line eqeqeq
    if (affiliation.id == selectedId) {
      pathToListItem = depthFirstSearch(affiliations, [affiliation]);
      subReloadAffiliation(affiliation, true);
    }

    return affiliation.affiliations.map(function (item) {
      return reloadAffiliation(item);
    });
  }

  affiliations.map(function (i) {
    return reloadAffiliation(i);
  }); // eslint-disable-next-line eqeqeq

  if (selectedId == -1) {
    // （-1）がすべてです
    listAllIdsFromLastItem = [];
  } else if (selectedId < 0) {
    // （全てグループ）の子供たち
    subReloadAffiliation(pathToListItem[pathToListItem.length - 2], false);
  }

  return {
    pathToListItem: pathToListItem,
    listAllIdsFromLastItem: listAllIdsFromLastItem
  };
} // 社員の所属を表示用の文字列にする。親子関係にある所属は「・」、系統が異なる所属は「/」で区切り、親のすぐ後ろに子を並べる

export function formatUserAffiliations(userAffiliations) {
  var list = userAffiliations || [];
  var ids = new Set(list.map(function (item) {
    return String(item.affiliation_id);
  }));
  var names = [];

  var append = function append(item, separator) {
    names.push((names.length ? separator : '') + item.affiliation.name);
    list.filter(function (child) {
      return String(child.affiliation.parent_id) === String(item.affiliation_id);
    }).forEach(function (child) {
      return append(child, ' ・ ');
    });
  };

  list.filter(function (item) {
    return !ids.has(String(item.affiliation.parent_id));
  }).forEach(function (item) {
    return append(item, ' / ');
  });
  return names.join('');
} // check is number

export function checkIsNumber(value) {
  var regNumber = /^[0-9]+$/;

  try {
    if (regNumber.test(Number(value))) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}
export function checkIsNumberAndComma(value) {
  var regNumber = /^[0-9.,]+$/;

  try {
    if (regNumber.test(value)) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}
export function extractExtAndNameFromFilename(fileName) {
  var extractFile = {
    nameFile: '',
    extension: ''
  };

  try {
    var file_name_array = fileName.split('.');
    extractFile.nameFile = file_name_array.slice(0, -1).join('.');
    extractFile.extension = file_name_array.pop();
    return extractFile;
  } catch (_unused) {
    return extractFile;
  }
}
export var urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#!=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#!?&//=]*)/g;
export var emailRegex = /([a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4})/ig;
export var mobileRegex = /\s+((\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})/g;